import DefaultModal from 'components/Modals'
import { WarningModal } from 'components/Modals/WarningModal'
import { useCallbackPrompt } from 'hooks/useCallbackPrompt'
import React, { Dispatch, SetStateAction } from 'react'
import { Beforeunload } from 'react-beforeunload'
import { AiOutlineExclamationCircle } from 'react-icons/ai'
import AnonymousInfoModal from '../modals/AnonymousInfoModal'
import DefaultMobileModal from 'components/MobileModal/MobileModal'
import DamageLevelInfoModal from '../modals/DamageLevelInfoModal'
import { NotifyEventType } from 'validator/notify_event_validator'
import NotificationConfirmation from '../modals/NotificationConfirmation'
import { SubmitHandler, UseFormGetValues, UseFormHandleSubmit } from 'react-hook-form'


interface IFormModals {
  isDirty: boolean
  isMobile: boolean
  showNotificationTypeInfoModal: boolean
  showReviewBeforeSubmit: boolean
  setShowReviewBeforeSubmit: Dispatch<SetStateAction<boolean>>
  setShowNotificationTypeInfoModal: Dispatch<SetStateAction<boolean>>
  showDamageLevelInfoModal: boolean
  setShowDamageLevelInfoModal: Dispatch<SetStateAction<boolean>>
  watchFormData: NotifyEventType
  handleSubmit: UseFormHandleSubmit<NotifyEventType, undefined>
  getValues: UseFormGetValues<NotifyEventType>
  chooseDamageLevel: (id: string) => void
  submitForum: SubmitHandler<NotifyEventType>
  thereIsFile: boolean
}
export default function FormModals({
  isDirty,
  isMobile,
  getValues,
  submitForum,
  handleSubmit,
  watchFormData,
  chooseDamageLevel,
  showReviewBeforeSubmit,
  showDamageLevelInfoModal,
  setShowReviewBeforeSubmit,
  setShowDamageLevelInfoModal,
  showNotificationTypeInfoModal,
  setShowNotificationTypeInfoModal,
  thereIsFile,
}: IFormModals) {
  const [showPrompt, confirmNavigation, cancelNavigation] = useCallbackPrompt(isDirty)

  return (
    <>
      {/* alert */}
      {isDirty && (
        <Beforeunload onBeforeunload={(event) => 'Você fez edições que não forma salvas.'} />
      )}
      <WarningModal
        icon={
          <AiOutlineExclamationCircle
            size={50}
            className="text-yellow"
          />
        }
        customStyle={{
          titleStyle: 'text-yellow'
        }}
        title="Notificação não enviada"
        subTitle="Tem certeza que deseja cancelar a notificação?
                Todos os dados serão apagados e não será possível recuperá-los."
        leftButtonAction={confirmNavigation as () => void}
        rightButtonAction={cancelNavigation as () => void}
        isOpen={showPrompt as boolean}
        handleCloseModal={cancelNavigation as () => void}
        leftButtonText="Cancelar e sair"
        rightButtonText="Continuar notificação"
      />
      {/* modal quer se identificar? */}
      <DefaultModal
        isOpen={showNotificationTypeInfoModal && !isMobile}
        handleCloseModal={() => {
          setShowNotificationTypeInfoModal(false)
        }}
        children={<AnonymousInfoModal close={() => {
          setShowNotificationTypeInfoModal(false)
        }} />}
      />
      <DefaultMobileModal
        closeModal={() => {
          setShowNotificationTypeInfoModal(false)
        }}
        isOpen={showNotificationTypeInfoModal}
        children={<AnonymousInfoModal close={() => {
          setShowNotificationTypeInfoModal(false)
        }} />}
      />
      {/* modal damage lvl? */}
      <DefaultModal
        isOpen={showDamageLevelInfoModal && !isMobile}
        handleCloseModal={() => {
          setShowDamageLevelInfoModal(false)
        }}
        children={<DamageLevelInfoModal
          chosenElementId={watchFormData.damage_level}
          chooseDamageLevel={chooseDamageLevel}
          close={() => {
            setShowDamageLevelInfoModal(false)
          }}
        />}
      />
      <DefaultMobileModal
        closeModal={() => {
          setShowDamageLevelInfoModal(false)
        }}
        isOpen={showDamageLevelInfoModal}
        children={<DamageLevelInfoModal
          chosenElementId={watchFormData.damage_level}
          chooseDamageLevel={chooseDamageLevel}
          close={() => {
            setShowDamageLevelInfoModal(false)
          }}
        />}
      />
      {/* modal confirm submit lvl? */}
      <DefaultModal
        isOpen={showReviewBeforeSubmit && !isMobile}
        handleCloseModal={() => {
          setShowReviewBeforeSubmit(false)
        }}
        children={<NotificationConfirmation
          close={() => {
            setShowReviewBeforeSubmit(false)
          }}
          handleSubmit={handleSubmit}
          submitForum={submitForum}
          getValues={getValues}
          thereIsFile={thereIsFile}
        />}
      />
      <DefaultMobileModal
        closeModal={() => {
          setShowReviewBeforeSubmit(false)
        }}
        isOpen={showReviewBeforeSubmit}
        children={<NotificationConfirmation
          close={() => {
            setShowReviewBeforeSubmit(false)
          }}
          handleSubmit={handleSubmit}
          submitForum={submitForum}
          getValues={getValues}
          thereIsFile={thereIsFile}
        />}
      />
    </>
  )
}
